import React from 'react';

/**
 * Composant ToggleSwitch - Un switch moderne et discret pour basculer entre deux options
 *
 * @param {Object} props
 * @param {string} props.value - Valeur actuelle ('sejour' ou 'enfant')
 * @param {Function} props.onChange - Callback appelé lors du changement (reçoit la nouvelle valeur)
 * @param {string} props.leftLabel - Label de l'option de gauche (par défaut: "Par séjour")
 * @param {string} props.rightLabel - Label de l'option de droite (par défaut: "Par nom/prénom enfant")
 */
const ToggleSwitch = ({
  value,
  onChange,
  leftLabel = "Par séjour",
  rightLabel = "Par nom/prénom enfant"
}) => {
  const isRightActive = value === 'enfant';

  return (
    <div className="flex items-center gap-3">
      <span className={`text-sm font-medium transition-colors ${
        !isRightActive ? 'text-gray-900' : 'text-gray-500'
      }`}>
        {leftLabel}
      </span>

      <button
        type="button"
        onClick={() => onChange(isRightActive ? 'sejour' : 'enfant')}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
          isRightActive ? 'bg-primary-600' : 'bg-gray-300'
        }`}
        role="switch"
        aria-checked={isRightActive}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform ${
            isRightActive ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>

      <span className={`text-sm font-medium transition-colors ${
        isRightActive ? 'text-gray-900' : 'text-gray-500'
      }`}>
        {rightLabel}
      </span>
    </div>
  );
};

export default ToggleSwitch;
